import { instance } from '@shared/api/config';
import { Abonent } from '@shared/types/osi/abonents';
import { path } from '../../index';

// Бэк (OSI.Core dev 34d6a1f): query param переименован onlyExternals → onlyArendators
export const getOsiAbonents = (osiId: number, onlyArendators = false): Promise<Abonent[]> =>
  instance.get(`${path}/${osiId}/abonents?onlyArendators=${onlyArendators}`);
